import { Outlet, useNavigate } from "react-router-dom";
import Header from "../generic/Header";
import { useEffect } from "react";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";

const BaseContainer = () => {
  const navigate = useNavigate();
  const { authuser } = useStateGetter();

  useEffect(() => {
    // if(!authuser.firstName){
    //   navigate('/')
    // }
  }, []);
  return (
    <div className="w-screen h-screen">
      <div className=" h-screen  overflow-y-hidden overflow-x-hidden ">
        <Header />

        <div className="flex flex-col w-screen h-screen pb-20  overflow-y-scroll overflow-x-hidden  ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
export { BaseContainer };
